import axiosInstance from '../../axiosConfig';

export async function closePositionRequest({ accountId, tradingsymbol, exchange, quantity, product }) {
    const response = await axiosInstance.post('/api/trading-hub/positions/close', {
        accountId,
        tradingsymbol,
        exchange,
        quantity,
        product,
    });
    return response.data;
}
